"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthStore = void 0;
var mobx_1 = require("mobx");
var socialAuthApi_1 = __importDefault(require("../api/socialAuthApi"));
var STORAGE_KEY = "pos.auth.userProfile";
var loadStoredProfile = function () {
    if (typeof sessionStorage === "undefined") {
        return null;
    }
    var raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) {
        return null;
    }
    try {
        return JSON.parse(raw);
    }
    catch (_a) {
        return null;
    }
};
var AuthStore = /** @class */ (function () {
    function AuthStore() {
        Object.defineProperty(this, "userProfile", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: loadStoredProfile()
        });
        Object.defineProperty(this, "isLoadingProfile", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        (0, mobx_1.makeObservable)(this, {
            userProfile: mobx_1.observable,
            isLoadingProfile: mobx_1.observable,
            fetchUserProfile: mobx_1.action.bound,
            logout: mobx_1.action.bound
        });
    }
    Object.defineProperty(AuthStore.prototype, "fetchUserProfile", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (params) {
            return __awaiter(this, void 0, void 0, function () {
                var userId, email, profile_1;
                var _this = this;
                var _a, _b;
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            userId = (_a = params.userId) === null || _a === void 0 ? void 0 : _a.trim();
                            email = (_b = params.email) === null || _b === void 0 ? void 0 : _b.trim();
                            if (!userId || !email) {
                                return [2 /*return*/];
                            }
                            this.isLoadingProfile = true;
                            _c.label = 1;
                        case 1:
                            _c.trys.push([1, , 3, 4]);
                            return [4 /*yield*/, socialAuthApi_1.default.getUserProfile(__assign(__assign({}, params), { userId: userId, email: email }))];
                        case 2:
                            profile_1 = _c.sent();
                            (0, mobx_1.runInAction)(function () {
                                _this.userProfile = profile_1;
                            });
                            if (typeof sessionStorage !== "undefined") {
                                sessionStorage.setItem(STORAGE_KEY, JSON.stringify(profile_1));
                            }
                            return [3 /*break*/, 4];
                        case 3:
                            (0, mobx_1.runInAction)(function () {
                                _this.isLoadingProfile = false;
                            });
                            return [7 /*endfinally*/];
                        case 4: return [2 /*return*/];
                    }
                });
            });
        }
    });
    Object.defineProperty(AuthStore.prototype, "logout", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            this.userProfile = null;
            if (typeof sessionStorage !== "undefined") {
                sessionStorage.removeItem(STORAGE_KEY);
                sessionStorage.removeItem("pos.socialAuth.accessToken");
                sessionStorage.removeItem("pos.socialAuth.googleUser");
                sessionStorage.removeItem("pos.socialAuth.facebookUser");
                sessionStorage.removeItem("pos.socialAuth.lineUser");
            }
        }
    });
    return AuthStore;
}());
exports.AuthStore = AuthStore;
exports.default = new AuthStore();
